module.exports = __webpack_public_path__ + "img/20220327_190834.ca7c6fa3.jpg";